<template>
    <div
        class="leading-0"
        :style="
            'font-size: ' +
            fontSize +
            'px; height: ' +
            size +
            'px; width: ' +
            size +
            'px;'
        "
    >
        <img
            v-if="user.avatar"
            :src="user.avatar"
            class="rounded-full object-contain"
        />
        <div
            class="flex items-center justify-center rounded-full bg-gray-300 p-[.25rem] text-center font-medium text-gray-800"
            :style="'height: ' + size + 'px; width: ' + size + 'px;'"
            v-else
        >
            <span>
                {{ user.initials }}
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: "UserAvatarRound",
    props: {
        user: {},
        size: {
            type: String,
            default: "24",
        },
    },
    computed: {
        sizeCss() {
            return "h-[" + this.size + "px] " + "w-[" + this.size + "px]";
        },
        fontSize() {
            return this.size / 2;
        },
    },
};
</script>
